import { Action, createSelector, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { RMessageAction } from './r-message.action';
import { Message } from '../../../../models/message/Message';
import { User } from '../../../../models/user/User';
import { getMessageScopeEnum, MessageUserScopeEnum } from '../../../../enums/rights/message-user-scope.enum';


interface RMessagesXsStateModel {
  viewOrgMessage: string;
  createOrgMessage: string;
  editOrgMessage: string;
  deleteOrgMessage: string;
}

const getDefaults = (): RMessagesXsStateModel => ({
  viewOrgMessage: null,
  createOrgMessage: null,
  editOrgMessage: null,
  deleteOrgMessage: null,
});

@State<RMessagesXsStateModel>({
  name: 'rMessages',
  defaults: getDefaults()
})
@Injectable()
export class RMessageXsState {

  //region SELECTORS
  @Selector()
  static canEditMessage(state: RMessagesXsStateModel): boolean {
    return state.editOrgMessage != null;
  }

  @Selector()
  static canDeleteMessage(state: RMessagesXsStateModel): boolean {
    return state.editOrgMessage != null;
  }

  @Selector()
  static hasViewOrgMessagePrivilege(state: RMessagesXsStateModel): boolean {
    return state.viewOrgMessage != null;
  }

  @Selector()
  static hasCreateOrgMessagePrivilege(state: RMessagesXsStateModel): boolean {
    return state.createOrgMessage !=null;
  }

  @Selector()
  static hasEditOrgMessagePrivilege(state: RMessagesXsStateModel): boolean {
    return state.editOrgMessage != null;
  }

  @Selector()
  static hasDeleteOrgMessagePrivilege(state: RMessagesXsStateModel): boolean {
    return state.deleteOrgMessage != null;
  }
  //endregion

  @Action(RMessageAction.SetMessagePrivileges)
  public setMessagePrivileges(ctx: StateContext<RMessagesXsStateModel>, action: RMessageAction.SetMessagePrivileges) {
    const state = ctx.getState();
    const messagePrivileges = [...action.activeUserRightInfoDtoModel.messagePrivileges];


    //find user privilege data model
    const viewOrgMessage = messagePrivileges.find(id => id === UserPrivilegeEnum.VIEW_MESSAGE);
    const createOrgMessage = messagePrivileges.find(id => id === UserPrivilegeEnum.CREATE_MESSAGE);
    const editOrgMessage = messagePrivileges.find(id => id === UserPrivilegeEnum.EDIT_MESSAGE);
    const deleteOrgMessage = messagePrivileges.find(id => id === UserPrivilegeEnum.DELETE_MESSAGE);


    //set the state
    ctx.setState({
      ...state,
      viewOrgMessage: viewOrgMessage,
      createOrgMessage: createOrgMessage,
      editOrgMessage: editOrgMessage,
      deleteOrgMessage: deleteOrgMessage,
    });
  }

}
